import { jarvisPublicApi } from './jarvis-api'

export default class PublicLawFirm {
  static getLogoUrl (id) {
    return jarvisPublicApi.get('/public/lawfirm/logo', {
      params: {
        law_firm_id: id
      }
    })
  }
}
